/* eslint-disable */
import { LibCategories, loadScript } from "src/utils/scriptLoader";

declare const window: Window & {
  TiktokAnalyticsObject: string;
  ttq: any;
};

window.TiktokAnalyticsObject = "ttq";

export const ttq = window.ttq || [];

// Tag setup
window.ttq = ttq;
ttq.methods = [
  "page",
  "track",
  "identify",
  "instances",
  "debug",
  "on",
  "off",
  "once",
  "ready",
  "alias",
  "group",
  "enableCookie",
  "disableCookie",
];
ttq.setAndDefer = function (t, e) {
  t[e] = function () {
    t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
  };
};
for (let i = 0; i < ttq.methods.length; i++) {
  ttq.setAndDefer(ttq, ttq.methods[i]);
}
ttq.instance = function (t) {
  const e = ttq._i[t] || [];
  for (let n = 0; n < ttq.methods.length; n++)
    ttq.setAndDefer(e, ttq.methods[n]);
  return e;
};
const identifier = "C6P4NB0394AQ13GJQN40";
const baseUrl = "https://analytics.tiktok.com/i18n/pixel/events.js";
ttq._i = ttq._i || {};
ttq._i[identifier] = [];
ttq._i[identifier]._u = baseUrl;
ttq._t = ttq._t || {};
ttq._t[identifier] = +new Date();
ttq._o = ttq._o || {};
ttq._o[identifier] = {}; // originally `n || {};` n seems undefined

export async function loadTikTok() {
  await loadScript(baseUrl + "?sdkid=" + identifier + "&lib=" + "ttq", [
    LibCategories.targetingCookies,
  ]);
  ttq.page();
}
